module.exports = __webpack_public_path__ + "static/media/gafa_forma.9514529c.svg";